var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const onCustomizeClick_V2 = ({ assignmentId, customizationMeals, setAssignmentId, setMeals, setIsAddDisabled, isAddDisabled, }) => __awaiter(void 0, void 0, void 0, function* () {
    //Set the current assignment so we can update it properly in the Customize modal
    setAssignmentId(assignmentId);
    setMeals(customizationMeals);
    setIsAddDisabled(isAddDisabled);
});
